import { cva } from '@/styled-system/css';

export const accordionHeaderTriggerRecipe = cva({
  base: {
    appearance: 'none',
    backgroundColor: 'Accordion.bg',
    borderRadius: 'inherit',
    display: 'block',
    inset: 0,
    position: 'absolute',
    zIndex: 0,
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'background-color, box-shadow',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease}',
    _focusVisible: {
      boxShadow: 'focus',
    },
  },
  variants: {
    expanded: {
      true: {
        backgroundColor: 'Accordion.Header.bg.selected',
        _active: {
          backgroundColor: 'Accordion.Header.bg.selectedPressed',
        },
        _notDisabled: {
          _hover: {
            backgroundColor: 'Accordion.Header.bg.selectedHover',
          },
        },
      },
      false: {
        _active: {
          backgroundColor: 'Accordion.Header.bg.pressed',
        },
        backgroundColor: 'bg.action.neutral.default',
        _notDisabled: {
          _hover: {
            backgroundColor: 'Accordion.Header.bg.hover',
          },
        },
      },
    },
  },
});
